/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Checked_PendingInputs */



/**
* | output |
* | --- |
* | "Not ready yet — the records haven't reached us." |
*
* @param {Canvas_Domain_Checked_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_checked_pending = /** @type {((inputs?: Canvas_Domain_Checked_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Checked_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch nicht bereit — die Einträge haben uns nicht erreicht.")
	return /** @type {LocalizedString} */ ("Not ready yet — the records haven't reached us.")
});